import { render, staticRenderFns } from "./BetfairSports.vue?vue&type=template&id=4a80c28c&"
import script from "./BetfairSports.vue?vue&type=script&lang=js&"
export * from "./BetfairSports.vue?vue&type=script&lang=js&"
import style0 from "./BetfairSports.vue?vue&type=style&index=0&id=4a80c28c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports